import { DRIVER_PICKUP as type } from '../actions/types';

const initialState = {
    pickupOrderLoading: false,
    pickupOrder: [],
    pickupOrderError: false,
    createPickupLoading: false,
    createPickup: [],
    createPickupError: false,
    getManifestListLoading: false,
    getManifestList: [],
    getManifestListError: false,
    getOrderByManifestNoLoading: false,
    getOrderByManifestNo: [],
    getOrderByManifestNoError: false,
    getPickupPartnersLoading: false,
    getPickupPartners: [],
    getPickupPartnersError: false,
    getPickupWarehousesLoading: false,
    getPickupWarehouses: [],
    getPickupWarehousesError: false
}

export default function driverPickupReducer(state = initialState, action){
    switch(action.type){
        case type.GET_PICKUP_ORDER:
            return {
                ...state,
                pickupOrderLoading: true
            }
        case type.GET_PICKUP_ORDER_SUCCESS:
            return {
                ...state,
                pickupOrder: action.payload, 
                pickupOrderLoading: false      
            }
        case type.GET_PICKUP_ORDER_FAIL:
            return {
                ...state,
                pickupOrderLoading: false,
                pickupOrderError: action.payload
            }
        case type.CREATE_PICKUP_MANIFEST:
            return {
                ...state,
                createPickupLoading: true
            }
        case type.CREATE_PICKUP_MANIFEST_SUCCESS:
            return {
                ...state,
                createPickup: action.payload, 
                createPickupLoading: false      
            }
        case type.CREATE_PICKUP_MANIFEST_FAIL:
            return {
                ...state,
                createPickupLoading: false,
                createPickupError: action.payload
            }
        case type.GET_MANIFEST_LIST:
            return {
                ...state,
                getManifestListLoading: true
            }
        case type.GET_MANIFEST_LIST_SUCCESS:
            return {
                ...state,
                getManifestList: action.payload, 
                getManifestListLoading: false      
            }
        case type.GET_MANIFEST_LIST_FAIL:
            return {
                ...state,
                getManifestListLoading: false,
                getManifestListError: action.payload
            }
        case type.GET_ORDER_BY_MANIFEST_NO:
            return {
                ...state,
                getOrderByManifestNoLoading: true
            }
        case type.GET_ORDER_BY_MANIFEST_NO_SUCCESS:
            return {
                ...state,
                getOrderByManifestNo: action.payload, 
                getOrderByManifestNoLoading: false      
            }
        case type.GET_ORDER_BY_MANIFEST_NO_FAIL:
            return {
                ...state,
                getOrderByManifestNoLoading: false,
                getOrderByManifestNoError: action.payload
            }
        case type.GET_PICKUP_PARTNER:
            return {
                ...state,
                getPickupPartnersLoading: true
            }
        case type.GET_PICKUP_PARTNER_SUCCESS:
            return {
                ...state,
                getPickupPartners: action.payload, 
                getPickupPartnersLoading: false      
            }
        case type.GET_PICKUP_PARTNER_FAIL:
            return {
                ...state,
                getPickupPartnersLoading: false,
                getPickupPartnersError: action.payload
            }
        case type.GET_PICKUP_WAREHOUSE:
            return {
                ...state,
                getPickupWarehousesLoading: true
            }
        case type.GET_PICKUP_WAREHOUSE_SUCCESS:
            return {
                ...state,
                getPickupWarehouses: action.payload, 
                getPickupWarehousesLoading: false      
            }
        case type.GET_PICKUP_WAREHOUSE_FAIL:
            return {
                ...state,
                getPickupWarehousesLoading: false,
                getPickupWarehousesError: action.payload
            }
        default:
            return state;
    }
}